import axios from 'axios'
import authHeader from '../../module/auth-header'
import { errorMessages } from '../messages'
import { alertActions, authActions } from '../actions'
import { uriConstants } from '../constants'
import store from '../'

export const defaultService = {
  handleService,
}

// ---------------------------------------------------------------------------
// 401 응답 분기 처리.
//
// 본 프로젝트의 401은 세 가지 의미를 가질 수 있다.
//   (a) Step-up 재인증 필요 — 보호 API(@RequireStepUp) 호출 시 서버 메모리에 인증 기록이 없거나 만료된 경우.
//       응답 body: { status: 401, payload: { code: 'STEPUP_REQUIRED' }, errors: {...} }
//       → 토큰 만료가 아니므로 로그아웃하지 않는다. 현재 페이지를 유지한 채 PasswordConfirmModal을 띄워 재인증 유도.
//   (b) 비밀번호 재확인 자체의 실패 (POST /portal/user/checkPw).
//       → PasswordConfirmModal의 catch가 직접 처리하므로 인터셉터는 통과만 시킨다.
//   (c) 그 외 401 — 일반 JWT 만료/위조 등.
//       → 기존 동작: 토큰 만료 안내 후 logOut.
// ---------------------------------------------------------------------------
axios.interceptors.response.use(
  function (response) {
    return response
  },
  function (error) {
    const status = error?.response?.status
    if (status === 401) {
      const code = error?.response?.data?.payload?.code
      const url = error?.config?.url || ''

      // (a) Step-up 재인증 필요. 현재 페이지로 돌아오게 link 값을 현재 location으로 설정.
      if (code === 'STEPUP_REQUIRED') {
        console.log('401 STEPUP_REQUIRED — open PasswordConfirmModal')
        const here = window.location.pathname + window.location.search
        store.dispatch(authActions.showPwdPopup(true, 'link', here))
        return Promise.reject(error)
      }

      // (b) checkPw 자체의 실패. 모달이 직접 catch로 처리하도록 인터셉터는 손대지 않는다.
      if (url.indexOf(uriConstants.CHECK_PWD) >= 0) {
        return Promise.reject(error)
      }

      // (c) 그 외 401 — 기존 토큰 만료 처리.
      console.log('401 Unauthorized')
      store.dispatch(
        alertActions.success({
          title: '오류',
          message: errorMessages.tokenError,
          isAuthenticateError: true,
          params: {
            type: 'SUCCESS',
            callback: () => {
              console.log('401 callback')
              store.dispatch(authActions.logOut('/loginIntro'))
            },
          },
        }),
      )
    }

    return Promise.reject(error)
  },
)

function handleService(params) {
  // console.log(params)
  /****************
    헤더 예제~
    *.defaultService 호출시 상단에 작성

    const headers = {
      'Content-type': 'application/x-www-form-urlencoded; charset=UTF-8',
      '기타 옵션등등..'
    }
  ****************/

  const headerType = params.headers ? params.headers : { headers: authHeader() }

  const switchMethod = (method) => {
    let paramStr
    if (method !== 'get' && !!params.params && typeof params.params === 'object') {
      const queryString = require('query-string')
      paramStr = queryString.stringify(params.params)
    } else {
      paramStr = params.params
    }

    // console.log(paramStr)

    switch (method) {
      case 'get':
        return axios[method](params.endPoint, headerType)

      default:
        return axios[method](params.endPoint, paramStr, headerType)
    }
  }

  return switchMethod(params.method)
}
